module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dialogVisible),
      expression: "dialogVisible"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideDialog
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container rack",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("ftc")('rack/rack')) + ":  \n\t\t\t\t\t"), (_vm.rack && _vm.rack.rack_id && _vm.rack.rack_name) ? _c('linkComponent', {
    attrs: {
      "url": '/rack/view/' + _vm.rack.rack_id,
      "text": _vm.rack.rack_name
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideDialog
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.unitsCount > 0) ? _c('div', {
    staticClass: "rack-wrapper",
    style: (("height: calc(" + (_vm.unitsCount + (_vm.ZeroDevices && _vm.ZeroDevices.length ? 1 : 0)) + " * 24px)"))
  }, [_vm._l((_vm.unitsCount), function(idx) {
    return _c('div', {
      key: idx,
      staticClass: "rack-unit-no",
      style: ('left: 0; top: ' + (idx - 1) * 24 + 'px')
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.unitsCount - idx + 1) + "\n\t\t\t\t\t")])
  }), _vm._v(" "), (_vm.Devices && _vm.Devices.length) ? [_vm._l((_vm.Devices), function(dev, jdx) {
    return _c('a', {
      key: 'dev-' + jdx,
      staticClass: "rack-unit-dev",
      class: {
        sr: dev.device_type === 'rackdevice/server', sw: dev.device_type === 'rackdevice/switch'
      },
      style: (_vm.deviceStyle(dev)),
      attrs: {
        "target": "_blank",
        "href": '/rackdevice/view/' + dev.device_id
      },
      on: {
        "mouseenter": function($event) {
          return _vm.deviceNameShow(dev, $event)
        },
        "mouseleave": _vm.deviceNameHide
      }
    }, [_c('span', {
      staticClass: "online-status-before",
      class: {
        active: dev.device_ports_active === true
      }
    }, [_vm._v("●")]), _vm._v(" "), (dev.__count <= 3) ? _c('span', [_vm._v(" " + _vm._s(dev.device_name))]) : _vm._e()])
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.deviceNameText),
      expression: "deviceNameText"
    }],
    staticClass: "device-name",
    style: (_vm.deviceNameStyle)
  })] : _vm._e(), _vm._v(" "), (_vm.ZeroDevices && _vm.ZeroDevices.length) ? [_c('div', {
    staticClass: "rack-unit-no",
    style: ('left: 0; top: ' + _vm.unitsCount * 24 + 'px')
  }, [_vm._v("0")]), _vm._v(" "), _vm._l((_vm.ZeroDevices), function(zDev, zdx) {
    return _c('a', {
      key: 'zdev-' + zdx,
      staticClass: "rack-unit-dev zero",
      style: (_vm.deviceStyle(zDev)),
      attrs: {
        "target": "_blank",
        "href": '/rackdevice/view/' + zDev.device_id
      },
      on: {
        "mouseenter": function($event) {
          return _vm.deviceNameShow(zDev, $event)
        },
        "mouseleave": _vm.deviceNameHide
      }
    }, [_c('span', {
      staticClass: "online-status-before",
      class: {
        active: zDev.device_ports_active === true
      }
    }, [_vm._v("●")]), _vm._v(" "), (zDev.__count <= 3) ? _c('span', [_vm._v(" " + _vm._s(zDev.device_name))]) : _vm._e()])
  })] : _vm._e(), _vm._v(" "), (_vm.Devices && _vm.Devices.length) ? _c('div', {
    staticClass: "legend"
  }, [_c('span', {
    staticClass: "sr"
  }, [_vm._v(_vm._s(_vm._f("ftc")('rackdevice/server')))]), _vm._v(" "), _c('span', {
    staticClass: "sw"
  }, [_vm._v(_vm._s(_vm._f("ftc")('rackdevice/switch')))]), _vm._v(" "), (_vm.ZeroDevices && _vm.ZeroDevices.length) ? _c('span', {
    staticClass: "zero"
  }, [_vm._v("zero unit")]) : _vm._e()]) : _vm._e()], 2) : _c('div', {
    staticClass: "rack-wrapper empty"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/loading16.gif")
    }
  })])]), _vm._v(" "), (_vm.rackPlace && _vm.rackPlace.id && _vm.rackPlace.name) ? _c('div', {
    staticClass: "modal-footer rack"
  }, [(_vm.rack && _vm.rack.rack_type) ? _c('span', [_vm._v(_vm._s(_vm._f("ftc")((_vm.filters && _vm.filters.rack_type && _vm.filters.rack_type.list && _vm.filters.rack_type.list[_vm.rack.rack_type]) || _vm.rack.rack_type)))]) : _vm._e(), _vm._v(" "), _c('linkComponent', {
    attrs: {
      "url": '/datacenter/view/' + _vm.rackPlace.id,
      "text": _vm.rackPlace.name,
      "flagicon": 'flag-icon-' + _vm.rackPlace.country
    }
  }), _vm._v(" "), (_vm.rack && _vm.rack.rack_units) ? _c('span', [_vm._v(_vm._s(_vm.rack.rack_units))]) : _vm._e(), _vm._v(" "), (_vm.rack && _vm.rack.rack_power) ? _c('span', [_vm._v(_vm._s(_vm.rack.rack_power))]) : _vm._e(), _vm._v(" "), (_vm.rack && _vm.rack.rack_price) ? _c('span', [_vm._v(_vm._s(_vm.rack.rack_price))]) : _vm._e()], 1) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70174d54"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/rack.vue
// module id = 538
// module chunks = 0